import httpRequest from 'httpRequest'
import { CountryContract } from 'models'

const COUNTRY_PREFIX = '/countries'

const countryService = {
    getCountries: () => httpRequest.get<CountryContract[]>(COUNTRY_PREFIX),
}

export default countryService
